import React, { ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  GridRow,
  GridColumn,
  Loader,
} from "@screencloud/screencloud-ui-components";

import { startCreate } from "../../actions";
import { EditorStore } from "../../types";
import { RootState } from "../../reducers";

import newStream from "../../assets/new-stream.svg";
import "./StreamLanding.scss";

const StreamLanding = (): ReactElement<void> => {
  const dispatch = useDispatch();
  const editor: EditorStore = useSelector((state: RootState) => state.editor);

  return (
    <GridRow>
      <GridColumn width={16}>
        <div className="initial-setup">
          <img src={newStream} alt="Set up a Streaming Channel" />
          <div className="initial-setup_content">
            <h3>
              A Streaming Channel is like your own dedicated TV channel for
              live, episodic content.
            </h3>
            <p>
              Once you set up a Streaming Channel you can use Zoom or OBS to
              broadcast live video to it any time you need to.
            </p>
            <Button
              primary
              className="new-stream-button"
              onClick={() => dispatch(startCreate())}
            >
              {editor.createLoading ? (
                <Loader
                  inline="centered"
                  active
                  size="medium"
                  className="createLoader"
                />
              ) : (
                <span>Set up your first Streaming Channel</span>
              )}
            </Button>
          </div>
        </div>
      </GridColumn>
    </GridRow>
  );
};

export default StreamLanding;
